import { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";

const useStickyElement = (selector, bottom) => {
	const [elementTop, setElementTop] = useState(undefined);
	const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

	useEffect(() => {
		const element = document.querySelector(selector)?.getBoundingClientRect();
		setElementTop(bottom ? element?.bottom : element?.top);
	}, [selector]);

	useEffect(() => {
		if (!elementTop) return;
		let lastScrollY = 0;

		const handleScroll = () => {
			const element = document.querySelector(selector);
			const header = document.querySelector(".sticky-header");
			const headerTop = header?.getBoundingClientRect()?.top;
			const scrollPosition = window.scrollY;
			const threshold = bottom ? 600 : 5;
			const isBottomMobile = bottom && isMobile;
			const stickyClass = isBottomMobile ? "is-sticky-bottom" : "is-sticky";

			const isScrollingUp = scrollPosition < lastScrollY;

			if (
				(isBottomMobile && scrollPosition >= elementTop + threshold) ||
				(!bottom && scrollPosition >= elementTop + threshold)) {
				element.classList.add(stickyClass);
			}
			else if ((isBottomMobile && scrollPosition <= elementTop - 160) || (scrollPosition === 0)) {
				element.classList.add(isBottomMobile && "is-sticky-bottom");
			}
			else {
				element.classList.remove(stickyClass);
			}
			if (scrollPosition === 0) {
				element.classList.remove("is-sticky");
			}

			if (isMobile && header && selector === ".sticky-hero") {
				header.style.transition = "transform 0.3s ease-in-out";
				isScrollingUp
					? (header.style.position = "sticky",
					header.style.transform = "translateY(0)")
					: (header.style.position = "relative",
					headerTop < -100 && (header.style.transform = "translateY(-100%)"));
			}
		
			lastScrollY = scrollPosition; 
		};

		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [elementTop, selector]);

};

export default useStickyElement;

export const useStickyState = (stickyCTA) => {
	const [isSticky, setIsSticky] = useState(false);

	useEffect(() => {
		if (!stickyCTA) return;

		const button = document.querySelector(".make-sticky");
		const cachedOffsetTop = button?.offsetTop;

		const onScroll = () => {
			window.scrollY > cachedOffsetTop + 500 ? setIsSticky(true) : setIsSticky(false);
		};

		window.addEventListener("scroll", onScroll);
		return () => window.removeEventListener("scroll", onScroll);
	}, [stickyCTA]);

	return isSticky;
};